/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export const slug = 'glowingblue-orell-articles';
